"use strict";

exports.__esModule = true;
exports.default = void 0;
var _uuid = _interopRequireDefault(require("uuid"));
var _actionTypes = require("./actionTypes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const reducer = (state = {}, action) => {
  switch (action.type) {
    case _actionTypes.INIT_APITESTER:
      return {
        ...state,
        baseUrl: action.data.baseUrl,
        endpoint: action.data.endpoint,
        httpMethod: action.data.httpMethod,
        headerKey: action.data.headerKey,
        headerValue: action.data.headerValue,
        body: action.data.body,
        isFetching: action.data.isFetching,
        dataReturned: action.data.dataReturned,
        showDefaultShortcuts: action.data.showDefaultShortcuts,
        shortcuts: action.data.shortcuts,
        headers: action.data.headers
      };
    case _actionTypes.NEW_HEADER_CREATED:
      {
        const newHeader = {
          id: _uuid.default.v4(),
          headerKey: '',
          headerValue: ''
        };
        return {
          ...state,
          headers: [...state.headers, newHeader]
        };
      }
    case _actionTypes.ID_TOKEN_COPIED:
      for (let i = 0; i < state.headers.length; i++) {
        if (state.headers[i].headerKey === 'Authorization') {
          if (state.headers[i].headerValue === action.data.headerValue) {
            // key and value are right, do nothing

            return state;
          } else {
            // key is right but token is not, refresh token

            return {
              ...state,
              headers: state.headers.map(item => {
                if (item.headerKey === 'Authorization') {
                  return {
                    ...item,
                    headerValue: action.data.headerValue
                  };
                } else return item;
              })
            };
          }
        }
      }

      // no authorization header

      return {
        ...state,
        headers: [action.data, ...state.headers]
      };
    case _actionTypes.URL_KEY_PRESSED:
      if (action.data) document.getElementById("submitButton").disabled = false;else document.getElementById("submitButton").disabled = true;
      return {
        ...state,
        endpoint: action.data
      };
    case _actionTypes.HEADER_KEY_PRESSED:
      return {
        ...state,
        headers: state.headers.map(item => {
          if (item.id === action.data.id) {
            if (action.data.name === 'headerKey') {
              return {
                ...item,
                headerKey: action.data.value
              };
            } else {
              return {
                ...item,
                headerValue: action.data.value
              };
            }
          } else return item;
        })
      };
    case _actionTypes.HTTP_METHOD_CHANGED:
      return {
        ...state,
        httpMethod: action.data
      };
    case _actionTypes.BODY_CHANGED:
      return {
        ...state,
        body: action.data
      };
    case _actionTypes.SHORTCUT_SUBMITTED:
      {
        const shortcut = action.data;
        return {
          ...state,
          endpoint: shortcut.endpoint,
          httpMethod: shortcut.httpMethod,
          //headers: shortcut.headers,
          body: shortcut.body,
          isFetching: true
        };
      }
    case _actionTypes.SUCCESSFUL_REQUEST:
      {
        const emptyHeaders = [{
          id: _uuid.default.v4(),
          headerKey: '',
          headerValue: ''
        }];
        return {
          ...state,
          dataReturned: action.data,
          headers: [...emptyHeaders],
          isFetching: false
        };
      }
    default:
      return state;
  }
};
var _default = exports.default = reducer;
module.exports = exports.default;